import { Avatar, Box, FormControl, FormLabel, Input, Stack } from '@mui/joy';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import Chip from '@mui/joy/Chip';
import IconButton from '@mui/joy/IconButton';
import SvgIcon from '@mui/joy/SvgIcon';
import Typography from '@mui/joy/Typography';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import usePublicProfile from '../../hooks/usePublicProfile';

function PublicProfile() {
  const params = useParams();
  const publicProfileQuery = usePublicProfile(params.userId as string);
  const { t } = useTranslation();

  if (!publicProfileQuery.isSuccess) return null;

  const isAdmin =
    publicProfileQuery.data.role === 'ADMIN' ||
    publicProfileQuery.data.role === 'SUPER_ADMIN';

  const profile = publicProfileQuery.data;
  return (
    <Card sx={{ width: '320px', margin: 'auto', boxShadow: 'lg' }}>
      <CardContent sx={{ alignItems: 'center', textAlign: 'center' }}>
        <Avatar src={profile.imageUrl} sx={{ '--Avatar-size': '4rem' }} />
        {isAdmin && (
          <Chip
            size="sm"
            variant="soft"
            color="primary"
            sx={{
              mt: -1,
              mb: 1,
              border: '3px solid',
              borderColor: 'background.surface',
            }}
          >
            Medewerker
          </Chip>
        )}
        <Typography level="title-lg">{`${profile.firstName} ${
          profile.lastName ? profile.lastName : ''
        }`}</Typography>

        <Typography level="body-md" sx={{ maxWidth: '24ch' }}>
          {`Vestiging: ${profile.branch}`}
        </Typography>

        <Typography level="body-sm" sx={{ maxWidth: '24ch' }}>
          {profile.description ? profile.description : 'Geen beschrijving'}
        </Typography>
      </CardContent>
      <CardOverflow sx={{ bgcolor: 'background.level1' }}>
        <CardActions buttonFlex="1">
          <ButtonGroup
            variant="outlined"
            sx={{ bgcolor: 'background.surface' }}
          >
            <Button disabled>Knop 1</Button>
            <Button disabled>Knop 2</Button>
          </ButtonGroup>
        </CardActions>
      </CardOverflow>
    </Card>
  );
}

export default PublicProfile;
